import { KataSearchViewModelItem } from './KataSearchViewModelItem';
import { KataSearchFolderItem } from './KataSearchFolderItem';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { sidebarSearchKeywordAtom } from '../sidebarSearchKeywordAtom';
import { searchResultsAtom } from '../SearchResult/trpcSearchResultState';
import { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';

export const KataSearchResult: React.FC = () => {
  const trpcResults = useAtomValue(searchResultsAtom);

  const searchKeyword = useAtomValue(sidebarSearchKeywordAtom);

  const workspace = useMemo(() => {
    if (!trpcResults?.kataResults.workspaces) return null;
    return Object.values(trpcResults.kataResults.workspaces)[0] ?? null;
  }, [trpcResults]);

  const rootFolderTree = useMemo(() => {
    if (!workspace) return null;
    return RootFolderTree.load(trpcResults?.kataResults.folderTrees[workspace.id] || {});
  }, [trpcResults, workspace]);

  const sortedFolders = useMemo(() => {
    if (!rootFolderTree || !trpcResults?.kataResults.folders) return [];

    return rootFolderTree
      .getFolderIdsOfRoot()
      .map((folderId) => trpcResults.kataResults.folders[folderId])
      .filter((folder) => !!folder)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [rootFolderTree, trpcResults]);

  const sortedViewModels = useMemo(() => {
    if (!rootFolderTree || !trpcResults?.kataResults.viewModels) return [];

    return rootFolderTree
      .getViewModelIdsOfRoot()
      .map((viewModelId) => trpcResults.kataResults.viewModels[viewModelId])
      .filter((viewModel) => !!viewModel)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [rootFolderTree, trpcResults]);

  if (!workspace || !rootFolderTree || (sortedFolders.length === 0 && sortedViewModels.length === 0)) {
    return null;
  }

  return (
    <div>
      <div className="text-xs font-bold">KATA（Balus共通）</div>
      <div className="ml-4">
        <div>
          {sortedFolders.map((folder) => (
            <KataSearchFolderItem
              key={folder.id}
              workspace={workspace}
              rootFolderTree={rootFolderTree}
              folder={folder}
              searchKeyword={searchKeyword}
            />
          ))}
        </div>
        <div>
          {sortedViewModels.map((viewModel) => (
            <KataSearchViewModelItem key={viewModel.id} viewModel={viewModel} searchKeyword={searchKeyword} />
          ))}
        </div>
      </div>
    </div>
  );
};
